import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import * as authenticationService from '../../data-layer/authentication/service';
import {
    addNewCollectionIdentifiers,
    setCollectionsRecords,
} from '../../data-layer/collections/actions';
import * as collectionsService from '../../data-layer/collections/service';
import { DEFAULT_COLLECTION_ID } from '../../data-layer/collections/service';
import { showNotificationAsync } from '../../data-layer/notifications/actions';
import { useDispatch } from '../../data-layer/useDispatch';
import { SaveToCollectionDrawer } from '../../ui/users/SaveToCollectionDrawer';
import { useBackButton } from '../../utils/useBackButton';
import { DEFAULT_CLOSE_ANIMATION_DELAY } from '../constants';
import { useCollectionsController } from './useCollectionsController';

export const SaveToCollectionDialog = () => {
    const { state } = useLocation();
    const postId = state?.postId;
    const dispatch = useDispatch();
    const onNavigateBack = useBackButton();
    const controller = useCollectionsController();

    const closeDialog = useCallback(() => {
        setTimeout(onNavigateBack, DEFAULT_CLOSE_ANIMATION_DELAY);
    }, [onNavigateBack]);

    const onSaveToExistentCollection = useCallback(
        authenticationService.protect(async (collectionId: string) => {
            try {
                const response = await collectionsService.saveToExistentCollection(
                    collectionId,
                    postId,
                );
                dispatch(setCollectionsRecords(...response.records.collections));
            } catch (error) {
                dispatch(showNotificationAsync('Не удалось сохранить пост в коллекцию'));
            }
            closeDialog();
        }),
        [dispatch, postId, onNavigateBack, closeDialog],
    );

    const onSaveToNewCollection = useCallback(
        authenticationService.protect(async (collectionName: string) => {
            try {
                const response = await collectionsService.saveToNewCollection(
                    collectionName,
                    postId,
                );
                dispatch(setCollectionsRecords(...response.records.collections));
                dispatch(addNewCollectionIdentifiers(response.collections));
            } catch (error) {
                dispatch(showNotificationAsync('Не удалось сохранить пост в коллекцию'));
            }
            closeDialog();
        }),
        [dispatch, postId, onNavigateBack, closeDialog],
    );

    if (!postId) {
        return null;
    }

    return (
        <SaveToCollectionDrawer
            isCollectionsLoading={controller.isLoading}
            collections={controller.collections.filter(
                (collection) => collection.id !== DEFAULT_COLLECTION_ID,
            )}
            onSaveToExistentCollection={onSaveToExistentCollection}
            onSaveToNewCollection={onSaveToNewCollection}
            onClose={closeDialog}
        />
    );
};
